// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZAPM","col":"styles_col__1ryI_"};